<div
  class="bg-primary w-full flex items-center justify-between px-4 py-2 gap-3 z-[1002] relative"
  [ngClass]="{ 'md:hidden': !forceMobileLayout }"
>
  <button
    type="button"
    class="flex-shrink-0 w-10 h-10 flex flex-col justify-center items-center gap-1.5 bg-transparent rounded p-2 focus:outline-2 focus:outline-offset-2 focus:outline-white"
    (click)="onToggleMenu()"
    [attr.aria-label]="
      isMenuOpen
        ? ('preview.label.closemenu' | translate)
        : ('preview.label.openmenu' | translate)
    "
    [attr.aria-expanded]="isMenuOpen"
    aria-controls="preview-sidebar"
  >
    <span
      aria-hidden="true"
      class="w-6 h-0.5 bg-white transition-all duration-300"
      [class.rotate-45]="isMenuOpen"
      [class.translate-y-2]="isMenuOpen"
    ></span>
    <span
      aria-hidden="true"
      class="w-6 h-0.5 bg-white transition-all duration-300"
      [class.opacity-0]="isMenuOpen"
    ></span>
    <span
      aria-hidden="true"
      class="w-6 h-0.5 bg-white transition-all duration-300"
      [class.-rotate-45]="isMenuOpen"
      [class.-translate-y-2]="isMenuOpen"
    ></span>
  </button>

  @if (previewMode === PreviewMode.FreeFlow) {
    <div class="flex-1 min-w-0 relative">
      <button
        type="button"
        class="goto-dropdown-button w-full"
        (click)="onToggleGotoMenu()"
        [attr.aria-label]="'preview.label.goto' | translate"
        [attr.aria-expanded]="isGotoMenuOpen"
      >
        {{ "preview.label.goto" | translate }}
      </button>

      @if (isGotoMenuOpen) {
        <div class="goto-dropdown-menu absolute" role="menu">
          @for (page of availablePages; track $index) {
            @if (page.name !== "thankyou") {
              <button
                type="button"
                (click)="onGoToChange({ type: 'page', key: page.name })"
                role="menuitem"
              >
                {{ page.translationKey | translate }}
              </button>
            }
          }

          @for (question of questions; track $index) {
            <button
              type="button"
              (click)="
                onGoToChange({ type: 'question', key: question.questionId })
              "
              role="menuitem"
            >
              {{ $index + 1 + ". " + question.name }}
            </button>
          }

          @for (page of availablePages; track $index) {
            @if (page.name === "thankyou") {
              <button
                type="button"
                (click)="onGoToChange({ type: 'page', key: page.name })"
                role="menuitem"
              >
                {{ page.translationKey | translate }}
              </button>
            }
          }
        </div>
      }
    </div>

    <div class="flex-1 min-w-0">
      <ng-select
        labelForId="topbar-language-select"
        bindValue="code"
        bindLabel="title"
        [items]="languages"
        searchable="false"
        class="topbar-select"
        (change)="onLanguageChange($event)"
        [(ngModel)]="selectedLanguage"
        clearable="false"
        [placeholder]="'preview.label.language' | translate"
      ></ng-select>
    </div>
  }

  @if (previewMode === PreviewMode.SimulateResponse) {
    <div class="flex-1 min-w-0 flex items-center gap-3">
      <span class="text-xs toggle-label">
        {{ "preview.label.rulesintext" | translate }}:
      </span>
      <button
        type="button"
        class="rules-toggle"
        [class.active]="isRulesInTextEnabled"
        (click)="onRulesInTextToggle()"
        role="switch"
        [attr.aria-checked]="isRulesInTextEnabled"
        [attr.aria-label]="'preview.label.rulesintext' | translate"
      >
        <span class="rules-toggle-slider"></span>
      </button>
      <span class="text-xs font-bold ml-1 toggle-status">
        {{
          isRulesInTextEnabled
            ? ("preview.label.show" | translate)
            : ("preview.label.hide" | translate)
        }}
      </span>
    </div>
  }
</div>
